import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { mergeMap, catchError, map, exhaustMap } from "rxjs/operators";
import { getRequestHeader } from "../../_helpers/request.header";
import { fundTransferConstants } from "../_constants";
import {
  fundTransferAccountDetailComplete,
  fundTransferAccountDetailError,
  fundTransferBankListComplete,
  fundTransferBankListError,
  fundTransferCurrencyConvertionComplete,
  fundTransferCurrencyConvertionError,
  fundTransferOTPComplete,
  fundTransferOTPError,
  fundTransferOwnInitializeComplete,
  fundTransferOwnInitializeError,
  fundTransferpayFromListComplete,
  fundTransferpayFromListError,
  fundTransferpayToListComplete,
  fundTransferpayToListError,
  fundTransferProceedComplete,
  fundTransferProceedError,
} from "../_actions/fundTransfer.actions";
import {
  ajaxError,
  payloadEncryptionFail,
  payloadEncryptionSuccess,
} from "../_actions";
import { payloadFormatter } from "../../_helpers/encryption.helper";

export const fundTransferpayFromListEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fundTransfers/payFromList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fundTransferpayFromListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fundTransferpayFromListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fundTransferpayToListEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fundTransfers/payToList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fundTransferpayToListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fundTransferpayToListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fundTransferCurrencyConvertionEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_CURRENCY_CONVERTION_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fundTransfers/currencyConverstion",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fundTransferCurrencyConvertionComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fundTransferCurrencyConvertionError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fundTransferInitializeEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_REQUEST),
    exhaustMap((action) =>
      from(
        (async () => {
          try {
            const finalPayload = { ...action.payload };
            delete finalPayload.restoreData;
            const payload = await payloadFormatter(
              finalPayload,
              "/api/fundTransfers/intiate",
            );
            return payloadEncryptionSuccess(payload, action.payload);
          } catch (error) {
            return payloadEncryptionFail(error);
          }
        })(),
      ).pipe(
        mergeMap((encryptedAction) => {
          if (!encryptedAction?.encryptedPayload) {
            return of(encryptedAction);
          }
          return ajax
            .post(
              "/api/fundTransfers/intiate",
              encryptedAction.encryptedPayload,
              getRequestHeader("POST"),
            )
            .pipe(
              map((ajaxResponse) =>
                fundTransferOwnInitializeComplete(ajaxResponse.response),
              ),
              catchError((error) =>
                of(fundTransferOwnInitializeError(error), ajaxError(error)),
              ),
            );
        }),
      ),
    ),
  );

export const fundTransferOTPEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_OTP_REQUEST),
    exhaustMap((action) => {
      const finalPayload = { ...action.payload };
      delete finalPayload.restoreData;
      return ajax
        .post(
          "/api/fundTransfers/fundTransferOtp",
          finalPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => fundTransferOTPComplete(ajaxResponse.response)),
          catchError((error) =>
            of(fundTransferOTPError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fundTransferProceedEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_PROCEED_REQUEST),
    exhaustMap((action) => {
      const finalPayload = { ...action.payload };

      delete finalPayload.restoreData;
      return ajax
        .post(
          "/api/fundTransfers/fundTransferProceed",
          finalPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fundTransferProceedComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fundTransferProceedError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fundTransferpayBankListEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_BANK_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fundTransfers/payToBanksList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fundTransferBankListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fundTransferBankListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const fundTransferValidateAccountDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(fundTransferConstants.FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/fundTransfers/validateAccountDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            fundTransferAccountDetailComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(fundTransferAccountDetailError(error), ajaxError(error)),
          ),
        );
    }),
  );
